import { createFileRoute } from '@tanstack/react-router';
import { ReferenceView } from '../../reference/ReferenceView.js';

/** `/reference/$id` (1.AB-2): one SRD entry, read-only. */
export const Route = createFileRoute('/reference/$id')({
  component: ReferencePage,
});

function ReferencePage(): React.JSX.Element {
  const { id } = Route.useParams();
  return (
    <main className="cx-reference-page">
      <ReferenceView docId={id} surface="page" />
    </main>
  );
}
